<template>
  <div>
    <input
      :value="value"
      type="password"
      placeholder="Password"
      class="input"
      @input="$emit('input', $event.target.value)"
    >
  </div>
</template>

<script>
export default {
  name: 'PasswordInput',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
.input {
  padding: 8px 12px;
  font: $font-rw-400;
  background: $clr-10;
  border: solid 1px transparent;
}
</style>
